import { z } from "zod";

const dateTransform = z.preprocess(
  (val) => (val ? new Date(val as string) : null),
  z.date().nullable()
);

export const BuildingSchema = z.object({
  bid: z.number(),
  badate: dateTransform,
  bedate: dateTransform,
  bcid: z.number().nullable().optional(),
  bmid: z.number().nullable().optional(),
  bcontact: z.string().max(60).nullable().optional(),
  bcontactphone: z.string().nullable().optional(),
  bcontactemail: z.string().max(75).nullable().optional(),
  bcontact2: z.string().max(60).nullable().optional(),
  bcontactphone2: z.string().nullable().optional(),
  bcontactemail2: z.string().max(75).nullable().optional(),
  btype: z.string().max(24).nullable().optional(),
  bsector: z.string().max(24).nullable().optional(),
  bsize: z.number().nullable().optional(),
  bfloors: z.number().nullable().optional(),
  blayers: z.number().nullable().optional(),
  bpitch: z.number().nullable().optional(),
  broof: z.string().max(24).nullable().optional(),
  broofmat: z.string().max(50).nullable().optional(),
  bmaterial: z.string().max(24).nullable().optional(),
  bmaterial2: z.string().max(24).nullable().optional(),
  bmaterial3: z.string().max(24).nullable().optional(),
  bhatch: z.string().max(3).nullable().optional(),
  bheight: z.number().nullable().optional(),
  bbheight: z.number().nullable().optional(),
  bsys: z.string().max(24).nullable().optional(),
  bmfr: z.number().nullable().optional(),
  bmil: z.string().max(24).nullable().optional(),
  bwar: z.string().max(24).nullable().optional(),
  binstall: dateTransform,
  blastserv: dateTransform,
  bnextserv: dateTransform,
  blastrep: dateTransform,
  bnextrep: dateTransform,
  bname: z.string().max(60).nullable().optional(),
  bnum: z.string().max(18).nullable().optional(),
  bsame: z.string().max(3).nullable().optional(),
  baddr1: z.string().max(60).nullable().optional(),
  baddr2: z.string().max(60).nullable().optional(),
  bcity: z.string().max(32).nullable().optional(),
  bst: z.string().max(2).nullable().optional(),
  bzip: z.number().nullable().optional(),
  blatlon: z.string().max(24).nullable().optional(),
  bnotes: z.string().nullable().optional(),
  bcnt: z.string().max(42).nullable().optional(),
  bcntemail: z.string().max(80).nullable().optional(),
  bcntphone: z.string().nullable().optional(),
  bclaim: dateTransform,
  bclaimstatus: z.string().max(1).nullable().optional(),
  bview: z.string().max(3).nullable().optional()
});

// Create schemas (omit auto-generated fields)
export const CreateBuildingSchema = BuildingSchema.omit({ bid: true });

// Update schemas (make all fields optional except ID)
export const UpdateBuildingSchema = BuildingSchema.partial().required({ bid: true });

// Type definitions
export type Building = z.infer<typeof BuildingSchema>;
export type CreateBuilding = z.infer<typeof CreateBuildingSchema>;
export type UpdateBuilding = z.infer<typeof UpdateBuildingSchema>; 